import { render, staticRenderFns } from "./footer-nav.vue?vue&type=template&id=21b5aa68&scoped=true"
import script from "./footer-nav.vue?vue&type=script&lang=js"
export * from "./footer-nav.vue?vue&type=script&lang=js"
import style0 from "./footer-nav.vue?vue&type=style&index=0&id=21b5aa68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b5aa68",
  null
  
)

export default component.exports